/* eslint-disable */
import axios from 'axios';
import { API2_HOST } from '../../helpers/urlHelper';
import dayjs from 'dayjs';
import { groupBy, rgbColor, themeColors } from 'helpers/utils';
import store from 'store';
import { streamChunkReceived } from 'slices/glassDashboard/coqYearSlice';

const _URL = `${API2_HOST}/glass-management`;
//const _URL = `https://api2-dev.emplas.co.uk/v1/glass-management`;

const remakeCols = [
    // {
    //     accessor: 'customerCode',
    //     Header: 'Customer Code',
    //     isVisible: true
    // },
    {
        accessor: 'customerName',
        Header: 'Customer Name',
        isVisible: true
    },
    {
        accessor: 'jobNo',
        Header: 'Job No.',
        isVisible: true,
        type: 'ccf-odr-link',
    },
    {
        accessor: 'originalJobNo',
        Header: 'Original Job No.',
        isVisible: true
    },
    {
        accessor: 'dateRequired',
        Header: 'Required Date',
        isVisible: true
    },
    {
        accessor: 'glassID',
        Header: 'Glass ID',
        isVisible: true
    },
    {
        accessor: 'validationStage',
        Header: 'Pad. Resolution Stage',
        isVisible: true
    },
    {
        accessor: 'remakeNo',
        Header: 'No. Of Remakes',
        isVisible: true
    },
];

const backlogCols = [
    {
        accessor: 'CustomerName',
        Header: 'Customer Name',
        isVisible: true
    },
    {
        accessor: 'JobNo',
        Header: 'Job No.',
        isVisible: true
    },
    {
        accessor: 'PoNo',
        Header: 'PO No.',
        isVisible: true
    },
    {
        accessor: 'GlassId',
        Header: 'Glass ID',
        isVisible: true
    },
    {
        accessor: 'EmplasDeliveryDate',
        Header: 'Emplas Delivery Date',
        isVisible: true
    },
    {
        accessor: 'PoRequiredDate',
        Header: 'PO Required Date',
        isVisible: true
    },
];

const bitCols = [
    {
        accessor: 'customerCode',
        Header: 'Customer Code',
        isVisible: true
    },
    {
        accessor: 'customerName',
        Header: 'Customer Name',
        isVisible: true
    },
    {
        accessor: 'jobNo',
        Header: 'Job No.',
        isVisible: true,
    },
    {
        accessor: 'odrJobNo',
        Header: 'ODR Job No.',
        isVisible: true,
        type: 'ccf-odr-link',
    },
    {
        accessor: 'glassId',
        Header: 'Glass ID',
        isVisible: true
    },
    {
        accessor: 'emplasComment',
        Header: 'Comment',
        isVisible: true
    },
    {
        accessor: 'faultCode',
        Header: 'Fault Code',
        isVisible: true
    },
    {
        accessor: 'created',
        Header: 'Created',
        isVisible: true,
    },
    {
        accessor: 'photos',
        Header: 'Photos',
        isVisible: true,
        type: 'image'
    },
];

const disputeCols = [
    {
        accessor: 'recordedDate',
        Header: 'Raised',
        isVisible: true,
        type: 'date'
    },
    {
        accessor: 'jobNo',
        Header: 'Job No.',
        isVisible: true,
    },
    {
        accessor: 'originalJobNo',
        Header: 'Original Job No.',
        isVisible: true,
    },
    {
        accessor: 'customerName',
        Header: 'Customer Name',
        isVisible: true,
    },
    {
        accessor: 'glassId',
        Header: 'Glass ID',
        isVisible: true,
    },
    {
        accessor: 'faultSource',
        Header: 'Fault Source',
        isVisible: true,
    },
    {
        accessor: 'faultCodeOption',
        Header: 'Fault Code',
        isVisible: true,
    },
    {
        accessor: 'completeName',
        Header: 'Emplas Review',
        isVisible: true,
    },
    {
        accessor: 'padihamReviewName',
        Header: 'Padiham Review',
        isVisible: true,
    },
    {
        accessor: 'finalFaultEmplasName',
        Header: 'Final Fault Emplas',
        isVisible: true,
    },
    {
        accessor: 'finalFaultPadihamName',
        Header: 'Final Fault Padiham',
        isVisible: true,
    },
    {
        accessor: 'hoverText',
        Header: 'Note',
        isVisible: true,
    },
];

const stillageScanningCols = [
    {
        accessor: 'deliveryDate',
        Header: 'Delivery Date',
        isVisible: true,
    },
    {
        accessor: 'scannedDate',
        Header: 'Scanned Date',
        isVisible: true
    },
    {
        accessor: 'stillageNo',
        Header: 'Stillage No.',
        isVisible: true
    },
]


const defaultChartOptions = {
    tooltip: {
        trigger: 'axis',
        show: true,
        axisPointer: {
            type: 'shadow'
        },
        formatter: function (params) {
            return `<p>
                <span>${(dayjs(params[0]?.name).isValid() ? dayjs(params[0]?.name).format('DD/MM/YYYY') : params[0]?.name)}: </span>
                <span><b>${params[0]?.value}</b></span>
                </p>`;
        }
    },
    xAxis: {
        type: 'category',
        axisLabel: {
            interval: 0,
            rotate: 45,
        },
        data: [],
    },
    yAxis: {
        type: 'value',
    },
    series: [
        {
            type: 'bar',
            stack: 'Total',
            data: [],
        },
        {
            type: 'line',
            stack: 'Trend',
            silent: true,
            symbol: 'none',
            itemStyle: {
                color: rgbColor(themeColors.success)
            },
            data: []
        }
    ],
}

// Pass dates to all?
const getRemakeData = async (start, end) => {
    try {
        const res = await axios.get(`${_URL}/remakes?start=${start}&end=${end}`);
        if (res.status === 200)
            return res.data;

        return [];
    } catch (err) {
        console.log('Error fething remakes!', err);
        return [];
    }
}

const getBacklog = async (start, end) => {
    try {
        const res = await axios.get(`${_URL}/backlog?start=${start}&end=${end}`);
        if (res.status === 200 && res?.data?.data)
            return groupBy(res?.data?.data?.data, 'PoRequiredDate');

        return [];
    } catch (err) {
        console.log('Error fething backlog!', err);
        return [];
    }
}

const getBIT = async (start, end) => {
    try {
        const res = await axios.get(`${_URL}/bit?start=${start}&end=${end}`);
        if (res.status === 200 && res?.data) {
            const formatted = res?.data?.map(x => {
                return {
                    ...x,
                    created: dayjs(dayjs(x.created).format('YYYY/MM/DD')).toISOString(),
                    odrid: x?.odrId
                };
            }).sort((a, b) => dayjs(a.created) - dayjs(b.created));
            return groupBy(formatted, 'created');
        }

        return [];
    } catch (err) {
        console.log('Error fething BIT!', err);
        return [];
    }
}

const getShelled = async (start, end) => {
    try {
        const res = await axios.get(`${_URL}/shelled?start=${start}&end=${end}`);
        if (res.status === 200 && res?.data?.data) {
            const formatted = res?.data?.data?.data?.map(x => {
                return {
                    ...x, Created: dayjs(x.Created.split('T')[0]).toISOString()
                };
            }).sort((a, b) => dayjs(a.Created) - dayjs(b.Created));
            return groupBy(formatted, 'Created');
        }

        return [];
    } catch (err) {
        console.log('Error fething BIT!', err);
        return [];
    }
}

const getCoQ = async (start, end) => {
    const result = { graph: null, table: null };
    try {
        const res = await axios(`${_URL}/coq?start=${start}&end=${end}`, {
            method: 'GET',
            timeout: 0
        });
        if (res.status === 200) {
            const { data: { graph, table } } = res;
            if (graph?.success)
                result.graph = graph?.data;
            if (table?.success)
                result.table = table?.data;
        }

        return result;
    } catch (err) {
        console.log('Error fething CoQ!', err);
        return result;
    }
}

const getCoQYearData = async (start) => {
    try {
        const res = await axios(`${_URL}/coq-year?start=${start}`, {
            method: 'GET',
            timeout: 0
        });

        if (res.status === 200 && res?.data)
            return res.data?.data;
    } catch (err) {
        console.log('Error fething CoQ Yearly Summary!', err);
        return [];
    }
}

const getCoQYearDataStream = async (start) => {
    try {
        const res = await axios(`${_URL}/coq-year-stream?start=${start}`, {
            method: 'GET',
            timeout: 0,
            responseType: 'stream',
            adapter: 'fetch',
        });

        const reader = res.data.getReader();
        let done = false;
        const decoder = new TextDecoder('utf-8');
        let buffer = '';
        let finalData = [];

        while (!done) {
            const { value, done: readingDone } = await reader.read();
            done = readingDone;

            if (value) {
                buffer += decoder.decode(value, { stream: true });
                const chunks = buffer.split('\n\n');
                buffer = chunks.pop() || '';

                for (const chunk of chunks) {
                    if (chunk.startsWith('end')) {
                        done = true;
                        return finalData;
                    }
                    if (chunk.startsWith('error: ')) {
                        const errorMsg = chunk.substring(7);
                        console.log('Error fething CoQ Yearly Summary!', errorMsg);
                        throw new Error(errorMsg);
                    }
                    if (chunk.startsWith('data: ')) {
                        const jsonStr = chunk.substring(6);
                        const json = JSON.parse(jsonStr);
                        if (json?.success && json?.data) {
                            finalData = [...finalData, json.data?.yearSummary[0]];
                            store.dispatch(streamChunkReceived(finalData));
                        }
                    }
                }
            }
        }
        return finalData;
    } catch (err) {
        console.log('Error fething CoQ Yearly Summary!', err);
        throw err;
    }
}

const getTotals = async (start, end) => {
    try {
        const res = await axios.get(`${_URL}/totals?start=${start}&end=${end}`);
        if (res.status === 200 && res?.data)
            return res.data;

        return [];
    } catch (err) {
        console.log('Error fething totals!', err);
        return [];
    }
}

const getDisputes = async (start, end) => {
    try {
        const res = await axios.get(`${_URL}/dispute-summary?start=${start}&end=${end}`);
        if (res.status === 200 && res?.data)
            return res.data;

        return [];
    } catch (err) {
        console.log('Error fething disputes!', err);
        return [];
    }
}

const getOtherIssues = async (start, end) => {
    try {
        const res = await axios.get(`${_URL}/other-issues?start=${start}&end=${end}`);
        if (res.status === 200 && res?.data) {
            const formatted = res?.data?.map(x => {
                return {
                    ...x,
                    created: dayjs(dayjs(x.created).format('YYYY/MM/DD')).toISOString(),
                    odrid: x?.odrId
                };
            }).sort((a, b) => dayjs(a.created) - dayjs(b.created));
            return groupBy(formatted, 'created');
        }

        return [];
    } catch (err) {
        console.log('Error fething other issues!', err);
        return [];
    }
}

const getStillageData = async (start, end) => {
    try {
        const res = await axios.get(`${_URL}/stillage-data?start=${start}&end=${end}`);
        if (res.status === 200 && res?.data) {
            return res.data;
        }
    } catch (err) {
        console.log('Error fething stillage data!', err);
        return [];
    }
}

export {
    defaultChartOptions,
    getRemakeData,
    remakeCols,
    getBacklog,
    backlogCols,
    getBIT,
    bitCols,
    getShelled,
    getCoQ,
    getCoQYearData,
    getCoQYearDataStream,
    getDisputes,
    disputeCols,
    getOtherIssues,
    getTotals,
    getStillageData,
    stillageScanningCols
};